module.exports = __webpack_public_path__ + "static/media/icone-menu-insights.1717b84a.svg";